import { useState } from "react"
import { studentRequest } from "services/requests"

const prefix = "streaks"
const useApi = () => {
  const [isFetching, setIsFetching] = useState(false)

  const getStreakImage = async ({ streakItemId = 0, languageId = 2 }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}/reward?streakItemId=${streakItemId}&languageId=${languageId}`,
      body: null,
      method: "get",
    })
    if (!response.success) console.log(response.message)
    setIsFetching(false)
    return response.data || null
  }

  const setStreak = async ({
    educationLevelId = 0,
    learningLanguageId = 0,
    goal = 0,
  }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}`,
      body: {
        educationLevelId,
        learningLanguageId,
        goal,
      },
      method: "post",
    })
    if (!response.success) console.log(response.message)
    setIsFetching(false)
    return response.data || null
  }

  return {
    getStreakImage,
    setStreak,
    isFetching,
  }
}

export default useApi
